import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import AssisterFilter from './AssisterFilter';
import Table from './Table';
import AlertMessage from '../individualPortal/dashboard/AlertMsgs/AlertMessage';
import { ALL_USER_ROLES, USER_GROUPS } from '@constants/roles/userRoleTypes';
import { DELEGATION_HEADER_TYPES, labelNames, filterInputsMaxLength, DELEGATION_ALERT_MSGS,DELEGATION_FILTER_TITLE_TYPES } from '@constants/entity/entityConfig';


// Note paragraph available only for CSR group and Consumer.
const Note = ({ roleGroup }) => (
    (roleGroup === USER_GROUPS.CSR_GROUP || roleGroup === ALL_USER_ROLES.INDIVIDUAL) &&
    <div className="delegation__note">
        <p><FormattedMessage id="delegation_note_text"
            values={{ note: <b><FormattedMessage id="delegation_note"/></b> }}/></p>
    </div>
);

const InfoNote = () => { 
    return (
        <Fragment>
            <div className="usa-alert gi-alert gi-alert__left-accent gi-alert__info">
                <div className="gi-alert__icon">
                    <FontAwesomeIcon icon={faInfoCircle}/>
                </div>

                <div className="gi-alert__body">
                    <p className="gi-alert__text">
                        <FormattedMessage id={DELEGATION_ALERT_MSGS.ENTITYADMIN_PAGE_LOAD}/>
                    </p>
                </div>
            </div>
        </Fragment>
    );
};

const AssisterList = props => {
    
    const {
        roleGroup,
        firstPageLoad,
        filters,        
        spinner,
        pagination,
        tableData,
        tableColumns,        
        onChangeHandler,
        onResetHandler,
        onApplyHandler,
        pageNumber,
        onPageNumberChange        
    } = props;    

    return (
        <Fragment>            
            <h1 className="entityContainer__header"><FormattedMessage id={DELEGATION_HEADER_TYPES[roleGroup]}/></h1>            
            <div className="entityContainer__panelContainer gi-panel">
                <h4 className="entityContainer__filter-header"><FormattedMessage id={DELEGATION_FILTER_TITLE_TYPES[roleGroup]}/></h4>
                <Note roleGroup={roleGroup}/>            
                {
                    filters && Object.keys(filters).length > 0 &&
                <AssisterFilter
                    filterList={filters}
                    filterInputsMaxLength={filterInputsMaxLength}                
                    labelNames={labelNames}                
                    formName='filterForm'
                    handleChange={onChangeHandler}
                    resetHandler={onResetHandler}
                    applyHandler={onApplyHandler}
                />
                }
            </div>           
            {
                firstPageLoad ? 
                    <Fragment>
                        <div className="gi-panel">
                            <Table
                                data={tableData}
                                columns={tableColumns}
                            />
                            <InfoNote />
                        </div>
                    </Fragment>
                    : spinner && spinner.activeSpinnersQty > 0 ? <FormattedMessage id='spinner.loading_data' tagName='div'/>
                        :
                        <Fragment>
                            <Table
                                data={tableData}
                                columns={tableColumns}
                            />
                            {
                                !pagination.searchAPIInProgress && tableData && tableData.length == 0 ? <AlertMessage
                                    content={
                                        <FormattedMessage id={DELEGATION_ALERT_MSGS.DEFAULT}/>
                                    }
                                    type="info"
                                /> : null
                            }                            
                        </Fragment>
            }
            {
                pagination && pagination.count > 10 &&
            <ReactPaginate
                previousLabel={<FormattedMessage id="delegation_pagination_prev"/>}
                nextLabel={<FormattedMessage id="delegation_pagination_next"/>}
                breakLabel={'...'}
                breakClassName={'break-me'}
                previousClassName={'pagination_prev'}
                nextClassName={'pagination_next'}
                pageCount={Math.ceil(pagination.count / 10)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={onPageNumberChange}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                forcePage={pageNumber}
                hrefBuilder={() => {
                    return '#';
                }}
            />
            }
        </Fragment>
    );
};

export default AssisterList;